import { createFileRoute } from '@tanstack/react-router'
import { MusicDetailPage } from '@/pages/MusicDetail/MusicDetailPage'

export const Route = createFileRoute('/music/$musicId')({
  component: MusicDetailPage,
  head: () => ({
    meta: [
      {
        title: 'Music - Copshop',
      },
    ],
  }),
})
